// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"4eb2044c","126":"ba1db633","138":"fa1d9472","206":"5c53c1f0","479":"5fe59631","541":"9763c1fd","635":"0d67e278","670":"b176e8a8","800":"b466fd6f","990":"833eaef7"}[chunkId] + ".chunk.js";
};